/*
  NUMU Media 2026: "HAR I BRUG FOR MERE PLADS?" cards (APO option, css class "more-space-picker").

  APO renders one value per quantity and shows the one that matches "Vælg antal".
  This script, matched on the value title (config in snippets/numu-mere-plads.liquid):
  - gives each card its photo, description and per-card price badge
  - keeps a fixed order (Praktisk info, Program, Portfals, Lommekuvert 1-3, Fotostribe)
  - on desktop, hovering a card previews it in the big product photo (like
    Papirkvalitet); leaving the cards shows the invitation again, so a ticked
    card never replaces the invitation photo
  - turns off APO's own hover pop-up on these cards (it showed the old APO image)
  - keeps the customer's choices when they change "Vælg antal" (APO swaps to the
    value for the new quantity, which would otherwise drop the selection)
  The option itself is APO multi-select: nothing pre-selected, not required,
  click again to deselect, any combination.
*/
(function () {
  'use strict';
  if (window.__numuMerePlads) return;
  window.__numuMerePlads = true;

  var cfgEl = document.getElementById('numu-mere-plads-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  var byTitle = {};
  var byKey = {};
  CFG.items.forEach(function (it, i) {
    it.order = i + 1;
    byTitle[norm(it.title)] = it;
    byKey[it.key] = it;
  });

  var SEL = '.more-space-picker';

  /* ---------- Decorate cards ---------- */
  function itemFor(val) {
    var t = val.querySelector('.mw-stack--card__title');
    return t ? byTitle[norm(t.textContent)] : null;
  }

  /* APO attaches a tippy hover pop-up to each card (data-mw-tooltip). Switch it off. */
  function noTooltip(root) {
    var tips = root.querySelectorAll('[data-mw-tooltip]');
    for (var t = 0; t < tips.length; t++) {
      var tp = tips[t]._tippy;
      if (tp && tp.state && tp.state.isEnabled) { tp.hide(); tp.disable(); }
    }
  }

  function decorateValue(val) {
    var it = itemFor(val);
    if (!it) return;
    val.__numuMp = it;
    noTooltip(val);
    if (!val.classList.contains('numu-mp-value')) val.classList.add('numu-mp-value');
    if (val.getAttribute('data-numu-mp') !== it.key) val.setAttribute('data-numu-mp', it.key);
    if (val.style.order !== String(it.order)) val.style.order = it.order;

    var badge = val.querySelector('.mw-stack--badge__text');
    if (!badge) {
      var media = val.querySelector('.mw-stack--card__media-wrapper');
      if (media) {
        badge = document.createElement('span');
        badge.className = 'mw-stack--badge__text';
        media.insertBefore(badge, media.firstChild);
      }
    }
    if (badge && badge.textContent !== it.badge) badge.textContent = it.badge;

    var img = val.querySelector('img.mw-stack--card__media-wrapper--item, .mw-stack--card__media-wrapper img');
    if (img && it.img && img.getAttribute('src') !== it.img) {
      img.removeAttribute('srcset');
      img.setAttribute('src', it.img);
      img.setAttribute('alt', it.title);
    }

    var title = val.querySelector('.mw-stack--card__title');
    var desc = val.querySelector('.numu-mp-desc');
    if (!desc && title) {
      desc = document.createElement('p');
      desc.className = 'numu-mp-desc';
      title.insertAdjacentElement('afterend', desc);
    }
    if (desc && desc.textContent !== it.desc) desc.textContent = it.desc;
  }

  function decorate() {
    var opts = document.querySelectorAll(SEL);
    for (var i = 0; i < opts.length; i++) {
      var opt = opts[i];
      if (!opt.classList.contains('numu-mp')) opt.classList.add('numu-mp');
      var vals = opt.querySelectorAll('.mw-option__value');
      for (var j = 0; j < vals.length; j++) decorateValue(vals[j]);
    }
  }

  var queued = false;
  function queueDecorate() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; decorate(); }, 60);
  }

  /* ---------- Big product photo ---------- */
  var swappedImg = null;
  var hoverVal = null;
  var selected = []; // keys, latest last

  function galleryImage() {
    var imgs = document.querySelectorAll(
      '.product__media-wrapper .product__media-item.is-active .product__media img, .product__media-wrapper .product__media-list .product__media img'
    );
    for (var i = 0; i < imgs.length; i++) {
      var r = imgs[i].getBoundingClientRect();
      if (r.width > 120 && r.height > 120) return imgs[i];
    }
    return null;
  }

  function restoreGallery() {
    if (!swappedImg) return;
    var o = swappedImg.__numuOrig;
    if (o) {
      if (o.srcset) swappedImg.setAttribute('srcset', o.srcset); else swappedImg.removeAttribute('srcset');
      swappedImg.setAttribute('src', o.src);
    }
    swappedImg.classList.remove('numu-gallery-swapped');
    swappedImg = null;
  }

  function showInGallery(src) {
    var img = swappedImg || galleryImage();
    if (!img || !src) return;
    if (!img.__numuOrig) img.__numuOrig = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') };
    img.removeAttribute('srcset');
    if (img.getAttribute('src') !== src) img.setAttribute('src', src);
    img.classList.add('numu-gallery-swapped');
    swappedImg = img;
  }

  function checkedKeys() {
    var out = [];
    var inputs = document.querySelectorAll(SEL + ' .mw-option__value:not(.mw-hidden) input.mw-option__control:checked');
    for (var i = 0; i < inputs.length; i++) {
      var v = inputs[i].closest('.mw-option__value');
      if (v && v.__numuMp) out.push(v.__numuMp.key);
    }
    return out;
  }

  function showSelection() {
    var now = checkedKeys();
    selected = selected.filter(function (k) { return now.indexOf(k) !== -1; });
    now.forEach(function (k) { if (selected.indexOf(k) === -1) selected.push(k); });
    // The invitation stays in focus: only a hovered card is previewed in the big photo.
    if (hoverVal && hoverVal.__numuMp) return;
    restoreGallery();
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var val = t.closest(SEL + ' .mw-option__value');
    if (val) {
      decorateValue(val);
      var it = val.__numuMp;
      if (it) {
        selected = selected.filter(function (k) { return k !== it.key; });
        if (t.checked) selected.push(it.key);
      }
      setTimeout(showSelection, 0);
      return;
    }
    // "Vælg antal" changed: APO shows the values for the new quantity. Re-select the same choices.
    if (t.closest('.quantity-box') && document.querySelector(SEL)) {
      var keep = selected.slice();
      if (!keep.length) return;
      // Untick the current quantity's values before APO hides (and disables) them, so they
      // don't come back ticked if the customer later returns to that quantity.
      var cur = document.querySelectorAll(SEL + ' .mw-option__value:not(.mw-hidden) input.mw-option__control:checked');
      for (var c = 0; c < cur.length; c++) {
        if (!cur[c].disabled) cur[c].click();
      }
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        decorate();
        var done = true;
        keep.forEach(function (k) {
          var v = document.querySelector(SEL + ' .mw-option__value.numu-mp-value[data-numu-mp="' + k + '"]:not(.mw-hidden)');
          if (!v) { done = false; return; }
          var inp = v.querySelector('input.mw-option__control');
          if (inp && !inp.checked && !inp.disabled) {
            var lbl = v.querySelector('label');
            (lbl || inp).click();
          }
        });
        if ((done && tries > 2) || tries > 12) {
          clearInterval(timer);
          selected = keep.filter(function (k) { return checkedKeys().indexOf(k) !== -1; });
          showSelection();
        }
      }, 250);
    }
  }, true);

  /* Desktop: hovering a card previews it in the big photo (like Papirkvalitet). */
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  // Capture phase runs before tippy's own mouseenter, so the pop-up never opens.
  document.addEventListener('mouseover', function (e) {
    var v = e.target.closest && e.target.closest(SEL + ' .mw-option__value');
    if (v) noTooltip(v);
  }, true);
  document.addEventListener('mouseover', function (e) {
    if (!canHover.matches) return;
    var val = e.target.closest && e.target.closest(SEL + ' .numu-mp-value');
    if (val === hoverVal) return;
    hoverVal = val;
    if (val && val.__numuMp) showInGallery(val.__numuMp.img);
    else showSelection();
  });

  /* ---------- Start ---------- */
  decorate();
  var mo = new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      var m = list[i];
      if (m.type === 'childList' || (m.target && m.target.closest && m.target.closest(SEL))) {
        queueDecorate();
        return;
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'class'] });
})();
